import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon, CheckCircle2Icon } from 'lucide-react';
import { getText, isRtl, type Lang } from './translations';
export function IntakeIntroSlide({
  onStart,
  lang = 'en' as Lang
}: {
  onStart: () => void;
  lang?: Lang;
}) {
  const rtl = isRtl(lang);
  return <div className="flex flex-col h-full relative z-10 bg-white justify-between overflow-y-auto no-scrollbar" dir={rtl ? 'rtl' : 'ltr'} data-id="element-381">
      <div className="flex-1 flex flex-col items-center w-full" data-id="element-382">
        <div className="w-full px-6 py-4 flex justify-start" data-id="element-383">
          <img src="https://cdn.magicpatterns.com/uploads/eWJnHd6KU81M388b5WU5VJ/Screenshot_2026-03-10_at_18.49.55.png" alt="NHS Imperial College Healthcare" className="h-12 object-contain" data-id="element-384" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="w-full h-40 sm:h-48 relative mb-8 rounded-b-3xl overflow-hidden shadow-sm" data-id="element-385">
          <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=1000&auto=format&fit=crop" alt="Supportive clinic environment" className="w-full h-full object-cover object-[center_20%]" data-id="element-386" />
          <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-80" data-id="element-387" />
        </motion.div>

        <div className="px-6 max-w-sm mx-auto text-center" data-id="element-388">
          <motion.h1 initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15,
          duration: 0.5
        }} className="text-3xl font-semibold text-slate-900 leading-tight mb-5" data-id="element-389">
            {getText('introTitle', lang)}
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.4
        }} className="text-base text-stone-600 leading-relaxed mb-8" data-id="element-390">
            {getText('introBody1', lang)}
            <br data-id="element-391" />
            <br data-id="element-392" />
            {getText('introBody2', lang)}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.45,
          duration: 0.4
        }} className="flex flex-col items-start space-y-4 w-full bg-white p-5 rounded-2xl border border-stone-200 shadow-sm mb-8" data-id="element-393">
            <div className="flex items-center space-x-3 rtl:space-x-reverse" data-id="element-394">
              <CheckCircle2Icon className="w-5 h-5 text-nhs-blue" data-id="element-395" />
              <span className="text-sm font-medium text-stone-700" data-id="element-396">
                {getText('shortQuestions', lang)}
              </span>
            </div>
            <div className="flex items-center space-x-3 rtl:space-x-reverse" data-id="element-397">
              <ClockIcon className="w-5 h-5 text-nhs-blue" data-id="element-398" />
              <span className="text-sm font-medium text-stone-700" data-id="element-399">
                {getText('lessThanMinute', lang)}
              </span>
            </div>
          </motion.div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6,
      duration: 0.4
    }} className="w-full max-w-sm mx-auto px-6 pb-8 pt-4" data-id="element-400">
        <button onClick={onStart} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors group shadow-md shadow-nhs-blue/20 active:scale-[0.98]" data-id="element-401">
          {getText('start', lang)}
          <ArrowRightIcon className={`w-5 h-5 ${rtl ? 'mr-2 rotate-180' : 'ml-2'} group-hover:translate-x-1 transition-transform`} data-id="element-402" />
        </button>
      </motion.div>
    </div>;
}